// TestContent.js
import React from 'react';

const Organizations = () => {
  return (
    <div>
      <h1>Organizations</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Organizations;